export const PRODUCT_SCREEN_CREATION_MODE = 'CREATION_MODE';
export const PRODUCT_SCREEN_EDIT_MODE = 'EDIT_MODE';